import { CloseOutlined } from "@ant-design/icons"
import { Button, Modal, Form, Input, Collapse, Typography, Divider, PaginationProps, ConfigProvider, Pagination, } from "antd"


import '../../../../styles.scss'
import { avatar, avatarDefault } from "../../../../../../components/ExportImgFigma";
import { useEffect, useRef, useState } from "react";
import { addServiceSalesCareLogs, getListServiceSalesCareLogs, IListCustomerComplaintLogs, InfoServiceSalesCare } from "../../../../../../api/Customer_V2/customerApi_V2";
import { dataPagination, formatDate, formatDateToDMY, mapDocCode } from "../../../../../../until";
import useLoading from "../../../../../../hook/useLoading";
import useToast from "../../../../../../hook/useToast";
import useThrottle from "../../../../../../hook/useThrottle";
import { formatNumber } from "../../../../../../services/mixin";

import viVN from 'antd/locale/vi_VN';
import { NO_DATA } from "../../../../../../env";
import { dataInteractionCategory_V2 } from "../../../../../../services/data";


const { TextArea } = Input;
const { Text } = Typography;

interface ModalProps {
    isOpen: boolean
    idCustomer?: number
    infoModalSalesAndService?: InfoServiceSalesCare
    closeModal: (isOpen: boolean) => void
}
const ModalSalesAndServiceDetail: React.FC<ModalProps> = ({
    isOpen, idCustomer, infoModalSalesAndService,
    closeModal
}) => {

    const [form] = Form.useForm();

    const pushLoading = useLoading()
    const pushToast = useToast();

    const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
    const [dataListCustomerComplaintLogs, setDataListCustomerComplaintLogs] = useState<IListCustomerComplaintLogs[]>();
    const [valueDes, setValueDes] = useState<string>();


    const gListCustomerComplaintLogs = async (pageCurent: number = 1, pageSize: number = 20) => {
        // if (!infoCustomer?.id) return
        pushLoading(true)
        const result = await getListServiceSalesCareLogs(
            pageSize, pageCurent, idCustomer, infoModalSalesAndService?.id
        )
        if (result?.status) {
            setDataListCustomerComplaintLogs(result.data)
            setPagination({ current: pageCurent, total: result.total, pageSize: pageSize })
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }

    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListCustomerComplaintLogs(pageNumber, pageSize)
    }

    // chặn spam
    const handleAddCustomerComplaintLogs = useThrottle(async () => {
        // const valueDesTmp = valueDes?.trim()

        if (!idCustomer || !infoModalSalesAndService?.id || !infoModalSalesAndService?.adminId || !valueDes) {
            pushToast("Vui lòng nhập nội dung", 'warning');
            return;
        }
        pushLoading(true)
        const result = await addServiceSalesCareLogs(
            idCustomer, infoModalSalesAndService?.id, infoModalSalesAndService?.adminId, valueDes
        )
        if (result?.status) {
            setValueDes('')
            gListCustomerComplaintLogs()
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    useEffect(() => {
        if (infoModalSalesAndService?.id) {
            gListCustomerComplaintLogs()
        }
    }, [infoModalSalesAndService?.id])

    useEffect(() => {
        if (isOpen) {
            setValueDes('')
        }
    }, [isOpen])

    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Ghi chú thông tin chăm sóc bán hàng, dịch vụ</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
            </div>}
            open={isOpen}

            onCancel={() => closeModal(false)}
            centered
            className="custom-modal-ant-history"
            closeIcon={false}
            footer={''}
            destroyOnClose //xoá scroll

        >
            <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                <Collapse
                    defaultActiveKey={['general', 'car', 'support']}
                    ghost
                    expandIconPosition="end"
                >
                    {/* ================= Thông tin chung ================= */}
                    <Collapse.Panel
                        header={
                            <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>
                        }
                        key="general"
                    >
                        <div className="grid grid-cols-2  gap-2">
                            <InfoItemV2 label="Loại tương tác" value={mapDocCode(infoModalSalesAndService?.vehicleBookingDocCode)} />
                            <InfoItem label="Phân loại liên hệ" value={infoModalSalesAndService?.contactType} />

                            <InfoItem label="Ngày ghi nhận" value={formatDateToDMY(infoModalSalesAndService?.registrationDate)} />


                        </div>

                    </Collapse.Panel>

                    {/* ================= Thông tin xe ================= */}
                    <Collapse.Panel
                        header={
                            <span className="text-base text-344054 fw-500 font-medium">Thông tin xe</span>
                        }
                        key="car"
                    >
                        <div className="grid grid-cols-2 gap-2">
                            <InfoItem label="Tên xe" className={'uppercase'} value={infoModalSalesAndService?.carName} />
                            <InfoItem label="Biển số xe" className={'uppercase'} value={infoModalSalesAndService?.plateNumber} />

                            <InfoItem label="Số máy" className={'uppercase'} value={infoModalSalesAndService?.engineNo} />
                            <InfoItem label="Số khung" className={'uppercase'} value={infoModalSalesAndService?.chassisNo} />

                            <InfoItem label="Số Km hiện tại" value={infoModalSalesAndService?.currentMileageKm} />
                            <InfoItem label="Ngày nhắc BD 1000 km" value={infoModalSalesAndService?.maintenanceReminderDate} />

                            <InfoItem label="Nhân viên tiếp nhận" value={infoModalSalesAndService?.adminName} />
                            <InfoItem label="Đơn vị" value={infoModalSalesAndService?.branchName} />

                        </div>

                        <div className="custom-page-css  w-full bg-f2f8fd rounded p-4 flex flex-col gap-3 mt-2">
                            {/* Title */}
                            <span className="text-4E7FFF font-medium text-sm">
                                Nội dung liên hệ
                            </span>
                            {/* Action */}
                            <div className="custom-page-css flex flex-col items-end gap-3 bg-white p-2">
                                <TextArea
                                    placeholder="Nhập nội dung xử lý, tình trạng hiện tại"
                                    rows={4}
                                    className="rounded-md border-none"
                                    value={valueDes}
                                    onChange={(e) => setValueDes(e.target.value)}
                                />

                                <Button type="primary" size="small" className="custom-page-css w-fit "
                                    disabled={!valueDes || !valueDes.trim()}
                                    onClick={handleAddCustomerComplaintLogs}
                                >
                                    Gửi
                                </Button>
                            </div>
                        </div>

                        {/* lịch sử cập nhật */}
                        <div className="custom-page-css flex flex-col justify-between  h-full">

                            <div className="activity-timeline">

                                {
                                    dataListCustomerComplaintLogs?.map((item, i) => {
                                        const { dateCreate, description, adminCode, adminName, adminEmail } = item
                                        const [date, time] = dateCreate.split(" ")
                                        return (
                                            <div
                                                className={`timeline-item2 `}
                                                key={i}
                                            // className={`timeline-item ${i === activities.length - 1 ? "is-last" : ""}`}
                                            >
                                                {/* Line trong item */}


                                                {/* Cột thời gian */}
                                                <div className="timeline-time">
                                                    <Text>{date}</Text> <br />
                                                    <Text> {time} </Text>
                                                </div>


                                                {/* Nội dung */}
                                                <div className="timeline-content">
                                                    <div className="timeline-user">
                                                        <Text>{adminName} </Text>
                                                        <span className="cl096DD9 mr-4px">
                                                            {adminCode ? `(${adminCode})` : ''}
                                                        </span>
                                                        {/* <Text type="secondary">| {admin.}</Text> */}
                                                    </div>
                                                    <div className="timeline-email">{adminEmail}</div>

                                                    <div className="group-timeline-action">
                                                        <div className="text-344054 leading-relaxed whitespace-pre-line">
                                                            {description}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                dataListCustomerComplaintLogs?.length ?
                                    <ConfigProvider locale={viVN}>
                                        <div className="pagination-block">
                                            <Pagination
                                                className='rs-pagination'
                                                showSizeChanger
                                                current={pagination.current}
                                                pageSize={pagination.pageSize}
                                                total={pagination.total}
                                                pageSizeOptions={['10', '20', '50', '100']}
                                                itemRender={(page, type, originalElement) => {
                                                    // Chỉ custom khi là nút số trang
                                                    if (type === 'page') {
                                                        return <span>{formatNumber(page)}</span>;
                                                    }
                                                    // prev / next / jump-prev / jump-next giữ nguyên
                                                    return originalElement;
                                                }}
                                                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                                                onChange={onPaginationChange}
                                            />
                                        </div>
                                    </ConfigProvider>
                                    : ''
                            }
                        </div>
                    </Collapse.Panel>


                </Collapse>
            </div>
        </Modal>
    )
}
export default ModalSalesAndServiceDetail

const InfoItem = ({ label, value, className }: { label: string; value?: string, className?: string }) => (
    <div className="custom-page-css flex flex-col gap-1">
        <Text className="text-gray-500 text-sm">{label}:</Text>
        <Text className={`text-344054 pl-3  ${value ? className : ''}`}>
            {value || NO_DATA}
        </Text>
    </div>
);


const InfoItemV2 = ({ label, value, className }: { label: string; value?: string, className?: string }) => (
    <div className="custom-page-css flex flex-col gap-1">
        <Text className="text-gray-500 text-sm">{label}:</Text>
        <Text className={`text-344054 pl-3  ${value ? className : ''}`}>
            {dataInteractionCategory_V2.map(item => <>
                {item?.value === value && item?.label}</>)}
        </Text>
    </div>
);